import { RANK_BADGE_TIER_IDS } from '@/lib/ranks/rankBadgeSrc';

export type RankLadderRow = {
  tierId: string;
  earned: boolean;
  current: boolean;
};

// Season tiers are placement-based (no metric thresholds) and surface via
// SeasonTitlesList, so the ladder only covers metric tracks.
const NON_METRIC_TRACK_IDS = new Set(['season']);

// Highest tier first, so the ladder reads like the in-game progression panels.
export function trackLadderRows(input: {
  trackId: string;
  currentTierId?: string | null;
  unlockedTierIds: string[];
}): RankLadderRow[] {
  if (NON_METRIC_TRACK_IDS.has(input.trackId)) {
    return [];
  }
  const prefix = `${input.trackId}.`;
  const unlocked = new Set(input.unlockedTierIds);
  return RANK_BADGE_TIER_IDS.filter((id) => id.startsWith(prefix))
    .map((tierId) => ({
      tierId,
      earned: unlocked.has(tierId),
      current: tierId === input.currentTierId,
    }))
    .reverse();
}
